import AuthLink from './AuthLink-view';

export default AuthLink;
